/**
 * Toast notification composable
 * @see https://github.com/ankurk91/vue-toast-notification
 */
import Vue from 'vue'

export function useToast() {
    /**
     * Display a toast notification
     * @param {'success'|'error'|'info'|'warning'} type
     * @param {string} message
     * @param {object} options - Additional vue-toast-notification options
     */
    const show = (type, message, options = {}) => {
        // Null-safe: in test environments (jsdom) the toast plugin is not
        // registered, so Vue.$toast is undefined — calling .open() would
        // throw "Cannot read properties of undefined (reading 'open')".
        // Unit-test specs exercise composables that notify on state changes
        // (e.g. the experiencia watcher), so the call degrades to a no-op
        // instead of a Vue error warning.
        if (typeof Vue.$toast?.open !== 'function') {
            return;
        }
        Vue.$toast.open({
            message,
            type,
            ...options,
        })
    }

    return {
        success: (message, options) => show('success', message, options),
        error: (message, options) => show('error', message, options),
        info: (message, options) => show('info', message, options),
        warning: (message, options) => show('warning', message, options),
    }
}
